
//Provide a nice component here for displaying alerts
export const catchBody = (error: any) => {
    if (!error.response || !error.response.data) {
        alert("Eroare necunoscută: " + JSON.stringify(error));
        return;
    }
    alert(error.response.data.title + "\n" + error.response.data.detail);
};
